import { Navigate, Outlet } from "react-router";
import { CREATE, DELETE, MODIFY, USER, VIEW, useFoodpilotContext } from "src/context/FoodpilotContext";

export const UsersProtection = () => {
    const { canUser } = useFoodpilotContext();
    const canManageUsers =
        canUser(VIEW, USER) || canUser(CREATE, USER) || canUser(MODIFY, USER) || canUser(DELETE, USER);

    if (!canManageUsers) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};
